import { IJobMatching } from '@orientaction/components/Form/CreateEditAdmin/Job/type';

const INITIAL_STATE: { job: IJobMatching | null } = {
  job: null,
};

const JobReducer = (state = INITIAL_STATE, action: any): { job: IJobMatching | null } => {
  switch (action.type) {
    case 'UPDATE_JOB':
      return {
        ...state,
        job: action.payload,
      };
    case 'RESET':
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default JobReducer;
